import { EpisodeTask, MovieTask } from '../types/huawei-recording';

export class ExtensionInfo {
  constructor(private recording: MovieTask | EpisodeTask) {}

  public get(key: string) {
    return this.recording.extensionInfo?.find((info) => info.key === key)?.value;
  }

  public parse<T>(key: string, parse: (value: string) => T) {
    const value = this.recording.extensionInfo?.find((info) => info.key === key)?.value;
    return value ? parse(value) : undefined;
  }
}
